const autoNgTemplateLoaderTemplate1 = require('./ldap-users-datatable.html');

export const ldapUsersDatatable = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
  },
};
